import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { InboxService } from '../../../core/src/lib/inbox.service';

@Injectable({
  providedIn: 'root',
})
export class SettingsAccessGuard {
  constructor(readonly inboxService: InboxService, private router: Router) {}

  canActivate(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _: ActivatedRouteSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.inboxService.canAccessEmbeddedSettings$.pipe(
      tap((canAccess) => {
        if (!canAccess) {
          this.router.navigate([{ outlets: { inbox: 'inbox' } }]);
        }
      }),
    );
  }
}
